export default "__VITE_ASSET__DB9Ifa4d__"